import { formatPostalCodeForCountry } from '../postalCodeConstants'

/**
 * Trims leading/trailing whitespace from referral string fields before API submit.
 * Does not replace or omit values — whitespace-only input becomes an empty string.
 */
export const trimReferralStringField = (
  value: string | null | undefined
): string | undefined => {
  if (value == null) return undefined
  return String(value).trim()
}

/**
 * Trims postal code, then applies country formatter when available.
 * Whitespace-only input becomes an empty string (not omitted).
 */
export const trimReferralPostalCodeForApi = (
  country: string | undefined,
  postalCode: string | number | null | undefined
): string | undefined => {
  const trimmed = trimReferralStringField(
    postalCode == null ? undefined : String(postalCode)
  )
  if (trimmed == null) return undefined
  if (trimmed === '') return ''
  return formatPostalCodeForCountry(country ?? '', trimmed) ?? trimmed
}

/**
 * Trims marketing-activity flag values. Does not substitute defaults.
 */
export const trimReferralMarketingActivityFlag = (
  value: string | null | undefined
): string | undefined => trimReferralStringField(value)

/**
 * Trims customer business problem text and removes zero-width chars sometimes
 * copied from CRM rich-text fields. Does not omit whitespace-only values.
 */
export const trimReferralBusinessProblemForApi = (
  value: string | null | undefined
): string | undefined => {
  if (value == null) return undefined
  return String(value)
    .replace(/\u200B/g, '')
    .trim()
}
